import { forwardRef } from 'react'

import { Label, Textarea } from '@/components/ui'
import { cn, slugify } from '@/utils'

export interface TextareaFieldProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string
  error?: string | null
  helpText?: string
  textareaClassName?: string
}

const TextareaField = forwardRef<HTMLTextAreaElement, TextareaFieldProps>(
  (
    { id, label, className, textareaClassName, error, helpText, ...props },
    ref,
  ) => {
    const _id = id ? id : `${slugify(label)}_${crypto.randomUUID()}`

    return (
      <div className={cn('space-y-2', className)}>
        <Label htmlFor={_id} className="text-sm font-medium">
          {label}
        </Label>
        <Textarea id={_id} className={textareaClassName} {...props} ref={ref} />
        {error && <p className="text-xs font-semibold text-red-500">{error}</p>}
        {helpText && (
          <p className="text-xs text-muted-foreground leading-relaxed">
            {helpText}
          </p>
        )}
      </div>
    )
  },
)
TextareaField.displayName = 'TextareaField'

export { TextareaField }
